import CouchdbClass from 'src/services/CouchdbClass'
import Couchdb from 'src/services/Couchdb'
import Vue from 'vue'
import VueNotify from 'vue-notifyjs'
import {mapActions, mapMutations, mapStates, mapGetters} from '../baseModule'
import eventsStore from './events'
import {dashboardCounter} from 'src/services/DashboardCounter.js'

Vue.use(VueNotify)
const collection = 'tickets'
const singleName = 'ticket'
const pluralName = 'tickets'
const model = {
  eventId: null,
  customerId: null,
  stockId: null,
  winner: false,
  documentedAt: null,
  barcode: null,
  eligible: true,
  reasonNotEligible: '',
  checkIn: false
}
const validations = {
  eventId: {required: true},
  customerId: {required: true},
  winner: {required: true},
  eligible: {required: true},
  barcode: {required: true},
  stockId: {required: false},
  documentedAt: {required: false}
}
let getters = {...mapGetters()}
getters[singleName] = (state) => state.one
getters[pluralName] = state => state.all
getters[`${pluralName}Winners`] = state => state.allWinners
getters = Object.assign(getters, {
  winners: state => state.all.filter(item => item.winner),
  elegibleNotWinner: state => state.all.filter(item => !item.winner && item.eligible),
  loading: state => state.loading,
  validations: state => state.validations,
  count: state => state.count,
  countWinners: state => state.countWinners,
  winningTickets: state => state.winningTickets,
  winningLoading: state => state.winningloading,
  winnersWithoutStock: state => state.all.filter(item => item.winner && item.stockId === null),
  ticketSearching: state => state.ticketSearching
})

const deleteExtraData = (ticket) => {
  delete ticket.canceledAt
  delete ticket.absentAt
  delete ticket.survey
  delete ticket.customer
  delete ticket.event
  delete ticket.stock
  return ticket
}

export default {
  namespaced: true,
  state: {
    ...mapStates(),
    loading: true,
    one: Object.assign({}, model),
    validations: validations,
    all: [],
    allWinners: [],
    count: 0,
    countWinners: 0,
    ticketSearching: false,
    winningTickets: 0,
    winningloading: true
  },
  mutations: {
    ...mapMutations(),
    setAllWinners: (state, payload) => {
      state.allWinners = payload
    },
    setCountWinners: (state, payload) => {
      state.countWinners = payload
    },
    SET_WINNING_TICKETS: (state, payload) => {
      state.winningTickets = payload
    },
    CHANGE_WINNING_LOADING: (state, payload) => {
      state.winningloading = payload
    },
    /**
     * Set checkIn data in ticket in all place
     * @param state - Vuex statment
     * @param _id - id of ticket
     * @param check - new value of checkIn
     */
    setCheckIn: (state, {_id, check}) => {
      if (state.all && state.all.length > 0) {
        for (let i in state.all) {
          if (state.all[i]._id === _id) {
            state.all[i].checkIn = check
            break
          }
        }
      }

      if (state.one._id && state.one._id === _id) {
        state.one.checkIn = check
      }
    },
    setTicketSearching: (state, payload) => {
      state.ticketSearching = payload
    },
    updateTickets: (state, tickets) => {
      tickets.forEach(ticket => {
        let indexState = state.all.reduce((acc, curr, index) => {
          if (curr._id === ticket._id) {
            return index
          }
        }, false)
        if (indexState) {
          state.all[indexState] = ticket
        }
      })
    }
  },
  actions: {
    ...mapActions(collection, model, 'default'),
    fetchAllWinners: (context, payload) => {
      payload = !payload ? {} : payload
      payload.stateMutations = {
        all: 'setAllWinners',
        count: 'setCountWinners'
      }
      context.dispatch('_all', payload)
    },

    async createTicket ({commit, state, dispatch}, payload) {
      commit('changeLoading', true)
      const couchdbAdmin = new CouchdbClass({connection: 'default', collection: 'tickets'})
      // payload.eventId
      let ticketCheck = await couchdbAdmin.where('customerId', payload.customerId).where('eventId', payload.eventId).get()
      // let barcodeCheck = await couchdbAdmin.where('barcode', payload.barcode).get()
      let barcodeCheck = await dispatch('fetchViewOne', { ddoc: 'tickets-by-barcode', view: 'tickets-by-barcode', key: payload.barcode, notCommit: true })
      if (ticketCheck.length === 0 && !barcodeCheck.hasOwnProperty('_id')) {
        return dispatch('insert', payload)
          .then(() => {
            dispatch('customers/fetchAllData', {id: payload.customerId}, {root: true})
            commit('changeLoading', false)
            return {
              ticketCreated: true,
              message: 'Ticket gerado com sucesso.'
            }
          })
          .catch(err => console.log(err))
      }
      if (ticketCheck.length > 0) {
        commit('changeLoading', false)
        return {
          ticketCreated: false,
          message: 'Já existe um ticket gerado para essa evento.'
        }
      }
      if (barcodeCheck.hasOwnProperty('_id')) {
        commit('changeLoading', false)
        return {
          ticketCreated: false,
          message: 'Já existe outro ticket com o mesmo código.'
        }
      }
    },

    async runLottery ({commit, dispatch}, {event, tickets}) {
      commit('changeLoading', true)

      if (event.numberOfRefigerators > tickets.filter(item => item.eligible).reduce((a, c) => {
        a += 1
        return a
      }, 0)) {
        return {error: 'Quantidades insuficientes de tickets'}
      }

      const alreadyWinners = tickets.filter(item => item.winner)
        .reduce((a) => {
          a += 1
          return a
        }, 0)
      const amountToWin = event.numberOfRefigerators - alreadyWinners
      const ticketsNotWinner = tickets.filter(item => !item.winner)

      if (amountToWin > ticketsNotWinner.length) {
        return {error: 'Quantidade de tickets insuficientes para o sorteio'}
      }

      let pickedIndexes = []
      while (pickedIndexes.length < amountToWin) {
        while (true) {
          let index = Math.floor(Math.random() * ticketsNotWinner.length)
          if (!pickedIndexes.find(item => item === index) && ticketsNotWinner[index]) {
            pickedIndexes.push(index)
            break
          }
        }
      }

      let ticketsToWin = []
      for (let index of pickedIndexes) {
        ticketsToWin.push(
          Object.assign(ticketsNotWinner[index], {winner: true})
        )
      }

      let oldEvent = await Couchdb.find(event._id)
      const eventUpdated = Object.assign(oldEvent, event, {drawn: true})
      await Couchdb._updateBulkDocs(ticketsToWin.concat(eventUpdated))
      return {ok: 'Sorteio realizado com sucesso.'}
    },

    associateStock ({dispatch, commit}, {tickets}) {
      tickets = tickets.map(item => {
        delete item.customer
        delete item.event
        delete item.stock
        return item
      }).reduce((acc, curr) => {
        if (!acc.hasOwnProperty(curr._id)) acc[curr._id] = curr
        return acc
      }, {})

      console.log(tickets, 'reduced')


      return dispatch('fetchAll', {where: {'_id': {'$in': Object.values(tickets).map(item => item._id)}}, limit: 99999})
        .then(docs => {
          docs = docs.map(doc => Object.assign(doc, tickets[doc._id], {_rev: doc._rev}))
          dispatch('updateMany', docs)
            .then(res => {
              dispatch('fetchTicketsWithCustomersByEvent', {eventId: tickets[0].eventId})
            })
        })
    },

    replaceTicketWinner ({dispatch}, {oldWinner, newWinner}) {
      newWinner.winner = true
      newWinner.stockId = oldWinner.stockId
      newWinner.checkIn = false
      oldWinner.winner = false
      oldWinner.stockId = null
      oldWinner.checkIn = false

      newWinner = deleteExtraData(newWinner)
      oldWinner = deleteExtraData(oldWinner)

      let newDdoc = {
        find: {database: 'default', ddoc: 'tickets-by-id', view: 'tickets-by-id', key: newWinner._id},
        payload: newWinner
      }
      let oldDdoc = {
        find: {database: 'default', ddoc: 'tickets-by-id', view: 'tickets-by-id', key: oldWinner._id},
        payload: oldWinner
      }

      let promises = [
        dispatch('upsertWithView', newDdoc),
        dispatch('upsertWithView', oldDdoc)
      ]
      Promise.all(promises)
        .then(() => {
          dispatch('fetchTicketsWithCustomersByEvent', {eventId: newWinner.eventId})
          return true
        })
        .catch(() => {
          return false
        })
    },

    setCheckIn ({commit}, {_id, check}) {
      commit('setCheckIn', {
        _id,
        check
      })
    },

    getTicketByBarCode ({commit}, {code}) {
      Couchdb.collection('tickets')
        .where('barcode', code)
        .first()
        .then(ticket => {
          if (!ticket) {
            commit('setTicketSearching', false)
            return false
          }
          commit('setTicketSearching', false)
          commit('setOne', ticket)
        })
        .catch(e => {
          console.log('error', e)
          commit('setTicketSearching', false)
        })
    },

    getFullTicketsByCustomerId ({dispatch}, customerId) {
      dispatch(
        'fetchAll', {
          sort: {
            field: 'createdAt',
            direction: 'descending'
          },
          where: [
            {'customerId': customerId}
          ],
          with: {
            event: {
              collection: 'events',
              localKey: 'eventId',
              foreignKey: '_id'
            },
            stock: {
              collection: 'stocks',
              localKey: 'stockId',
              foreignKey: '_id'
            }
          }
        })
    },

    setTicketSearching ({commit}, found) {
      commit('setTicketSearching', found)
    },

    setSurveyAssociated ({dispatch}, {tickets}) {
      Couchdb.connection('default').collection('tickets')
        ._updateBulkDocs(tickets.map(item => {
          item.updatedAt = new Date()
          return item
        }))
        .then(res => {
          dispatch('fetchTicketsWithCustomersByEvent', {
            eventId: tickets[0].eventId
          })
        })
    },

    makeRanking ({dispatch, commit}, tickets) {
      return new Promise((resolve) => {
        commit('changeLoading', true)
        if (tickets.length <= 0) {
          resolve(false)
          return
        }

        Couchdb.connection('default')
          .view({
            database: 'default',
            ddoc: 'tickets-by-id',
            view: 'tickets-by-id',
            keys: tickets.map(item => item._id)
          })
          .then(docs => {
            let event = Object.assign({}, eventsStore.state.one)

            tickets = tickets.reduce((acc, curr, index) => {
              if (index === 0) {
                acc = {}
              }
              delete curr._rev
              acc[curr._id] = curr
              return acc
            }, {})

            docs = docs.rows.map(item => item.value)

            docs = docs.map((ticket, index) => {
              ticket = Object.assign({}, ticket, tickets[ticket._id])
              if (index < event.numberOfRefigerators) {
                ticket.winner = true
                ticket.eligible = true
              } else {
                ticket.winner = false
                ticket.eligible = true
              }

              // @TODO: remover um dos delete abaixo (avaliar qual ou quais)
              delete ticket.canceledAt
              delete ticket.absentAt
              delete ticket.survey
              delete ticket.customer
              delete ticket.event
              delete ticket.stock

              return ticket
            })

            Couchdb.connection('default').collection('tickets')
              ._updateBulkDocs(docs)
              .then(response => {
                event.drawn = true
                dispatch('events/setEventDrawn', event, {root: true})
                resolve(true)
              })
              .catch(err => {
                console.log('err', err)
                resolve(false)
              })
          })
          .catch(err => {
            console.log('err', err)
            resolve(false)
          })
          .finally(() => commit('changeLoading', false))
      })
    },

    ticketCancel ({commit, dispatch}, {tickets, logs}) {
      commit('changeLoading', true)
      Couchdb.connection('default').collection('tickets')._updateBulkDocs(tickets).then(() => {
        dispatch('resetAll')
        dispatch('fetchTicketsWithCustomersByEvent', {
          where: {surveyAssociated: true},
          eventId: tickets[0].eventId
        })
        dispatch('insertLogs', logs)
      }).catch(err => console.log('err updatetickets', err))
        .finally(() => {
          commit('changeLoading', false)
        })
    },

    fetchAllDataFromTicketsByEvent ({commit, dispatch}, {eventId, options}) {
      commit('changeLoading', true)
      let keys = {startKey: eventId, startIndex: 0, endKey: eventId, endIndex: 5}
      Couchdb.connection('default')
        .viewBetween('event-datas', 'event-datas', keys, {
          include_docs: true,
          inclusive_end: true,
          reduce: false,
          skip: 0
        })
        .then(docs => {
          let tickets = []
          let customers = []
          let stocks = []
          let lamps = []

          for (let row of docs.rows) {
            let doc = row.doc
            if (!doc) {
              console.log(row)
              continue
            }

            let key = row.key[1]
            if (key === 0) {
              // event
              dispatch('events/setEvent', doc, {root: true})
            } else if (key === 1) {
              // ticket
              tickets.push(doc)
            } else if (key === 2) {
              // customer
              customers.push(doc)
            } else if (key === 3) {
              // stocks
              stocks.push(doc)
            } else if (key === 4) {
              // lamps
              lamps.push(doc)
            }
          }
          if (!options || options.lamps !== false) {
            dispatch('lamps/setStateAll', lamps, {root: true})
          }
          if (!options || options.customers !== false) {
            dispatch('customers/setStateAll', customers, {root: true})
          }
          if (!options || options.stocks !== false) {
            dispatch('stocks/setStateAll', stocks, {root: true})
          }

          commit('setAll', tickets)
        })
        .catch(err => console.log(err))
        .finally(() => commit('changeLoading', false))
    },

    fetchTicketsWithCustomersByEvent ({commit, dispatch}, {eventId, where}) {
      commit('changeLoading', true)
      let keys = {startKey: eventId, startIndex: 0, endKey: eventId, endIndex: 5}
      Couchdb.connection('default')
        .viewBetween('event-datas', 'event-datas', keys, {
          include_docs: true,
          inclusive_end: true,
          reduce: false,
          skip: 0
        })
        .then(docs => {
          let event = {}
          let tickets = []
          let customers = {}
          let customersList = []
          let stocks = {}
          let stocksList = []
          let lamps = []

          for (let row of docs.rows) {
            let doc = row.doc
            if (!doc) {
              console.log(row)
              continue
            }
            let key = row.key[1]
            if (key === 0) {
              // event
              event = doc
              dispatch('events/setEvent', event, {root: true})
            } else if (key === 1) {
              // ticket
              let valid = true
              for (let field in where) {
                valid = valid && doc.hasOwnProperty(field) && doc[field] === where[field]
              }
              if (valid) {
                tickets.push(doc)
              }
            } else if (key === 2) {
              // customer
              if (doc._id) {
                customers[doc._id] = doc
                customersList.push(doc)
              }
            } else if (key === 3) {
              // stocks
              if (doc._id) {
                stocks[doc._id] = doc
                stocksList.push(doc)
              }
            } else if (key === 4) {
              // lamps
              lamps.push(doc)
            }
          }

          // dispatch('lamps/setAll', lamps, {root: true})
          dispatch('stocks/setStateAll', stocksList, {root: true})
          dispatch('customers/setStateAll', customersList, {root: true})

          tickets = tickets.map(ticket => {
            ticket.event = event
            ticket.customer = customers[ticket.customerId]
            ticket.stock = ticket.stockId ? stocks[ticket.stockId] : ticket.stockId
            return ticket
          })

          commit('setAll', tickets)
        })
        .catch(err => console.log(err))
        .finally(() => commit('changeLoading', false))
    },

    fetchTicketCustomerEvent ({commit, dispatch}, {ticketId, where}) {
      commit('changeLoading', true)
      let keys = {startKey: ticketId, startIndex: 0, endKey: ticketId, endIndex: 3}
      Couchdb.connection('default')
        ._viewBetween('join-ticket-event-customer', 'join-ticket-event-customer', keys, {
          include_docs: true,
          inclusive_end: true,
          reduce: false,
          skip: 0
        })
        .then(docs => {
          if (!docs.rows) {
            return
          }

          let customers = []
          let tickets = []
          let stocks = []
          for (let data of docs.rows) {
            if (data.key[1] === 0) {
              tickets.push(data.doc)
            } else if (data.key[1] === 1) {
              dispatch('events/setStateOne', data.doc, {root: true})
            } else if (data.key[1] === 2) {
              customers.push(data.doc)
            } else if (data.key[1] === 3) {
              stocks.push(data.doc)
            }
          }

          if (customers.length > 0) {
            dispatch('customers/setStateAll', customers, {root: true})
          }
          if (stocks.length > 0) {
            dispatch('stocks/setStateAll', stocks, {root: true})
          }

          commit('setOne', tickets[0])
          commit('setAll', tickets)
          commit('changeLoading', false)
        })
        .catch(err => console.log(err))
    },

    getTicketsByEvent ({commit}, payload) {
      commit('changeLoading', true)
      Couchdb.viewQueries({
        database: 'default',
        ddoc: 'tickets-by-eventId',
        view: 'tickets-by-eventId',
        queries: [
          {
            key: payload
          }
        ]
      })
        .then(res => {
          let tickets = res[0].rows.map(item => item.value)
          commit('setAll', tickets)
        })
        .catch(err => {
          console.log('getticketbyeventserror', err)
        })
        .finally(() => {
          commit('changeLoading', false)
        })
    },

    dashboardTicketsByFilter (context, {eventsId, dateRange}) {
      context.commit('changeLoading', true)
      return dashboardCounter('tickets', eventsId, dateRange)
        .then(result => {
          context.commit('SET_DASHBOARD_COUNTER', result)
          context.commit('changeLoading', false)
          return result
        })
        .catch(err => {
          console.log(err)
          context.commit('changeLoading', false)
          return err
        })
    },
    dashboardWinnerTicketsByFilter (context, {eventsId, dateRange}) {
      context.commit('CHANGE_WINNING_LOADING', true)
      return dashboardCounter('winning-tickets', eventsId, dateRange)
        .then(result => {
          context.commit('SET_WINNING_TICKETS', result)
          context.commit('CHANGE_WINNING_LOADING', false)
          return result
        })
        .catch(err => {
          console.log(err)
          context.commit('CHANGE_WINNING_LOADING', false)
          return err
        })
    },
    isWinnerTrgNewer (context, {customer}) {
      return context.dispatch('fetchAll', {
        where: [{customerId: customer.id}],
        limit: 10
      }).then(result => {
        const winner = result.find(ticket => ticket.winner)
        // console.log('winner', winner, result)
        return winner
      })
    },
    checkWinnerOld (context, {config, customer, winner}) {
      let uc = config.validationContemplatedCustomer.uc && winner ? customer.uc === winner.uc : false

      let cpf = config.validationContemplatedCustomer.cpf && winner ? customer.cpf.replace(
        /\D/g,
        ''
      ) === winner.cpf : false

      let validPeriod = false
      if (winner && winner.exchangeDate !== '') {
        let period = parseInt(config.event.contemplatedPeriod)
        let currentYear = parseInt((new Date()).getFullYear())
        let exchangedAt = parseInt((new Date(winner.exchangeDate)).getFullYear())

        validPeriod = (exchangedAt + period) < currentYear
      }

      return config.validationContemplatedCustomer.uc && config.validationContemplatedCustomer.cpf ? uc && cpf && !validPeriod : (uc || cpf) && !validPeriod
    }
  },
  getters: getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/tickets.js